import { Constants } from "../shared/Constants";
import { clearAllCaches } from "../../../cache/appCache";

export function getLoginId(): string {
  const loggedInUser = localStorage.getItem(Constants.EASY_EDUM_LOGGED_IN_USER_ID);
  if (loggedInUser == null) throw new Error("No user logged in");
  else return loggedInUser;
}

export function getLoggedInUserName(): string {
  const loggedInUserName = localStorage.getItem(Constants.EASY_EDUM_LOGGED_IN_USER_NAME);
  if (loggedInUserName == null) throw new Error("No user logged in");
  else return loggedInUserName;
}

export function getLoggedInUserToken(): string {
  const loggedInUser = localStorage.getItem(Constants.EASY_EDUM_LOGGED_IN_USER_TOKEN);
  if (loggedInUser == null) throw new Error("No user logged in");
  else return loggedInUser;
}

/** The refresh token from login, or null. */
export function getRefreshToken(): string | null {
  return localStorage.getItem(Constants.EASY_EDUM_LOGGED_IN_USER_REFRESH_TOKEN) || null;
}

/** Replaces the access token after a refresh. */
export function saveAccessToken(token: string) {
  localStorage.setItem(Constants.EASY_EDUM_LOGGED_IN_USER_TOKEN, token);
}

export function isUserLoggedIn(): boolean {
  let userLoggedIn = localStorage.getItem(Constants.EASY_EDUM_IS_USER_LOGGED_IN);
  if (userLoggedIn) return true;
  else return false;
}

export function getLoggedInUserRole(): string {
  let loggedInUserRole = localStorage.getItem(Constants.EASY_EDUM_LOGGED_IN_USER_ROLE);
  if (loggedInUserRole !== undefined && loggedInUserRole !== null) return loggedInUserRole;
  else return undefined;
}

export function getLoggedInUserAdmissionNo(): string {
  let loggedInUserAdmissionNo = localStorage.getItem(Constants.EASY_EDUM_LOGGED_IN_USER_ADMISSION_NO);
  if (loggedInUserAdmissionNo !== undefined && loggedInUserAdmissionNo !== null) return loggedInUserAdmissionNo;
  else return undefined;
}

export function saveLoggedInUserData(loginData: any) {
  // every login starts with the desktop sidebar collapsed (icon rail)
  localStorage.removeItem(Constants.SIDEBAR_EXPANDED);
  // every login starts with empty caches (dashboard, academic years, fee structures, ...)
  clearAllCaches();

  localStorage.setItem(Constants.EASY_EDUM_IS_USER_LOGGED_IN, "true");
  localStorage.setItem(Constants.EASY_EDUM_LOGGED_IN_USER_ID, loginData.userName);
  localStorage.setItem(Constants.EASY_EDUM_LOGGED_IN_USER_TOKEN, loginData.token);
  localStorage.setItem(Constants.EASY_EDUM_LOGGED_IN_USER_REFRESH_TOKEN, loginData.refreshToken ?? "");
  localStorage.setItem(Constants.LAST_ACTIVITY_AT, String(Date.now()));
  localStorage.setItem(Constants.EASY_EDUM_LOGGED_IN_USER_ROLE, loginData.authorities[0]);
  localStorage.setItem(Constants.EASY_EDUM_LOGGED_IN_USER_ADMISSION_NO, loginData.userDTO.admissionNo);
  localStorage.setItem(Constants.EASY_EDUM_LOGGED_IN_USER_NAME, loginData.userDTO.name);
  localStorage.setItem(Constants.EASY_EDUM_LOGGED_IN_USER_GRADES, JSON.stringify(loginData.userDTO.grades ?? []));
}
export function removeLoggedInUser() {
  clearAllCaches();
  localStorage.removeItem(Constants.EASY_EDUM_IS_USER_LOGGED_IN);
  localStorage.removeItem(Constants.EASY_EDUM_LOGGED_IN_USER_ID);
  localStorage.removeItem(Constants.EASY_EDUM_LOGGED_IN_USER_TOKEN);
  localStorage.removeItem(Constants.EASY_EDUM_LOGGED_IN_USER_REFRESH_TOKEN);
  localStorage.removeItem(Constants.LAST_ACTIVITY_AT);
  localStorage.removeItem(Constants.EASY_EDUM_LOGGED_IN_USER_ROLE);
  localStorage.removeItem(Constants.EASY_EDUM_LOGGED_IN_USER_ADMISSION_NO);
  localStorage.removeItem(Constants.EASY_EDUM_LOGGED_IN_USER_ID);
  localStorage.removeItem(Constants.EASY_EDUM_LOGGED_IN_USER_NAME);
  localStorage.removeItem(Constants.EASY_EDUM_LOGGED_IN_USER_GRADES);
}

export const getUserGrades = (): string[] | null => {
  const value = localStorage.getItem(Constants.EASY_EDUM_LOGGED_IN_USER_GRADES);

  if (!value) {
    return null;
  }

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : null;
  } catch {
    return null;
  }
};
